<template>
    <div>
        <div ref="chat" class="chat">
            <div v-for="msg in messages" :key="msg.timestamp" >
                <div v-if="msg.user !== username" class="bubble others" >
                    <span class="user">{{msg.user}}:</span>
                    <br>
                    <span>{{msg.message}} </span>
                    <div class="timestamp">{{msg.time}} </div>
                </div>
                <div v-else class="bubble me">
                    <span>{{msg.message}} </span>
                    <br>
                    <span class="timestamp">{{msg.time}} </span>
                </div>
            </div>
        </div>
        <b-input-group>
            <b-input-group-text><b-icon-chat></b-icon-chat></b-input-group-text>
            <b-input type="text" v-model="type_box" v-on:keyup.enter="sendChatMessage"></b-input>
            <b-input-group-append>
                <b-button @click="sendChatMessage" variant="success" size="xl">Invia</b-button>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "ChatBox",
        props:['username'],
        data: function (){
            return {
                maxMessages: 100,
                type_box: '',
                messages: []
            }
        },
        computed:{
            messageHistory: function() {
                let msgh = '';
                for(let msg in this.messages){
                    msgh = msgh + this.messages[msg] + '\n';
                }
                return msgh
            }
        },
        methods:{
            sendChatMessage(){
                if(this.type_box.trim().length > 0){
                    let now = new moment();
                    let chatmessage = {
                        message: this.type_box,
                        user: this.username,
                        timekey: now.valueOf(),
                        time: now.format('HH:mm'),
                        date: now.format('D MMM YY')
                    };
                    this.pushMessage(chatmessage);
                    this.$emit('message', chatmessage);
                }
            },
            sendChatMessageWithContent: function(_content){
                if(_content.trim().length > 0){
                    let now = new moment();
                    let chatmessage = {
                        message: _content,
                        user: this.username,
                        timekey: now.valueOf(),
                        time: now.format('HH:mm'),
                        date: now.format('D MMM YY')
                    };
                    this.pushMessage(chatmessage);
                    this.$emit('message', chatmessage);
                }
            },
            cutChatHistory(){
                if(this.messages.length > this.maxMessages){
                    this.messages = this.messages.slice(Math.max(this.messages.length - this.maxMessages, 0));
                }
            },
            pushMessage(_message){
                this.messages.push(_message);
                this.type_box = '';
                this.cutChatHistory();
            }
        },
        updated(){
            this.$nextTick(function () {
                let container = this.$refs.chat;
                container.scrollTop = container.scrollHeight;
            })
        }
    }
</script>

<style scoped>

    .chat {
        overflow: auto;
        max-height: calc(100% - 50px);
        height: 100%;
        margin-bottom: 5px;
        border: 1px solid #cdcdcd;
        padding: 5px;
        border-radius: 5px;
        background-color: white;
    }

    .timestamp {
        font-size: 0.55em;
    }

    .user {
        color: #000000;
        font-size: 0.9em;
        font-weight: bolder;
        font-style: normal;
        text-transform: capitalize;
    }

    .bubble {
        font-size: 0.9em;
        min-width:51%;
        padding:5px 10px 5px 10px;
        margin:3px 0px 3px 0px;
        border-radius: 5px;
        word-break: break-word;
        box-shadow: 2px 2px 3px #bcc4cd;
    }

    .me{
        background-color: #a1e3e5;
        float:right;
        text-align: right;
    }

    .others{
        background-color: #c6efc6;
        text-align: left;
        float:left;
    }

</style>
